module.exports = __webpack_public_path__ + "images/category_lp/common/form-btn@2x_13e724174502538ab7f3b3a01683c854.png";